import { useCallback, useEffect, useState } from 'react';
import {
  fetchHomeQuickLinks,
  HomeQuickLink,
} from '@core/api/homeScreen/homeQuickLinks';

const useHomeQuickLinks = (role: string) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [quickLinks, setQuickLinks] = useState<HomeQuickLink[]>([]);

  const loadQuickLinks = useCallback(async () => {
    try {
      setIsLoading(true);
      setHasError(false);
      const { quickLinks: links } = await fetchHomeQuickLinks(role);
      setQuickLinks(links || []);
    } catch (e) {
      setQuickLinks([]);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [role]);

  useEffect(() => {
    loadQuickLinks();
  }, [loadQuickLinks]);

  return { quickLinks, isLoading, hasError, refetch: loadQuickLinks };
};

export default useHomeQuickLinks;
